import React, { useState } from "react";
import { Helmet } from 'react-helmet';
import { Container } from "react-bootstrap";
import SidebarDesktop from "../SidebarDesktop/SidebarDesktop";
import NavbarMobile from "../NavbarMobile/NavbarMobile";

const Page = ({ title, children, contentClassName = "" }) => {
    const [collapsed, setCollapsed] = useState(() => {
        const savedValue = localStorage.getItem("sidebarCollapsed");
        // Sem preferência salva, inicia com menu fechado.
        if (savedValue === null) return true;
        return savedValue === "true";
    });

    const handleToggle = () => {
        setCollapsed(prev => {
            const next = !prev;
            localStorage.setItem("sidebarCollapsed", next);
            return next;
        });
    };

    return (
        <Container className='p-0' fluid>
            <Helmet>
                <title>{title.toUpperCase() || "SGU"}</title>
            </Helmet>
            <div className="container-flex">
                <div className={`div1 sidebar-desktop${collapsed ? ' sidebar-collapsed' : ''}`}>
                    <SidebarDesktop collapsed={collapsed} onToggle={handleToggle} />
                </div>
                <div className="div2">
                    <div>
                        <NavbarMobile />
                    </div>
                    <div className={["p-2", "sgu-page-content", contentClassName].filter(Boolean).join(" ")}>
                        {children}
                    </div>
                </div>
            </div>
        </Container>
    );
};

export default Page;
